import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
// import PaymentSection from "../../Partials/Payment/PaymentSection";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Company } from "../../../Entity/Entities/Company/Company";
import Time from "../../../Time/Time";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CircularProgress from '@material-ui/core/CircularProgress';
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
// import * as ReactTooltip from "react-tooltip";
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import { QuickPaymentDialog } from "../../Partials/Dialog/QuickPaymentDialog";
import Memo from "../../Partials/Memo/Memo";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";

class Charges extends Component {
  protected selectedCharge: ChargeInterface;
  protected selectedChargeIndex: number;
  protected searchTimer;
  protected textFieldRef;
  public noteField: null;

  protected paginatorPath: string = `Finance_Charges_${this.props.app.financeChargesFilterState}_${this.props.app.financeChargesFilterDateState}_${this.props.app.financeChargesFilterSearchState}`;

  public state = {
    charges: [],
    unpaidCharges: [],
    filter: this.props.app.financeChargesFilterState,
    chargeToDelete: null,
    chargeToUnSettle: null,
    isChargeRemovePopupOpen: false,
    isChargeUnSettlePopupOpen: false,
    isSaving: false,
    anchorEl: null,
    hasModifiedData: false,
    openLeavePrompt: false,
    isFetching: true,
    filterValue: this.props.app.financeChargesFilterSearchState,
    chargesCount: 0,
    unpaidChargesCount: 0,
    chargeToUnlink: null,
    isPaymentUnlinkPopupOpen: false,
    dateFilter: this.props.app.financeChargesFilterDateState,
    includePayableFilter: false,
    includeReceivableFilter: false,
    selectedChargesRows: [],
    selectedCharges: [],
    step: 1,

    paymentChoice: "new",
    amountForPayment: "",
    currencyIdForPayment: null,
    firstDateOfStatementPeriodForPayment: new Date(),
    dateOfThePayment: new Date(),
    typeIdForPayment: "",
    typeNameForPayment: "Bank",
    agencyBankAccountIdForPayment: null,
    counterpartyIbanForPayment: "",
    counterpartyIbanForPaymentIsManuallyChanged: false,
    originalCounterpartyIban: "",
    paymentClassId: "",
    payerChoice: "person",
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    descriptionForPayment: "",
    descriptionForPaymentIsManuallyChanged: false,
    isCreateBankAccountPopupOpen: false,
    isChooseExistingChargePopupOpen: false,
    ibanUsedForEntity: null,
    cannotDeleteSavingsChargeDialog: false,
    searchInProgress: false,
    memoPopupOpen: false,
    note: "",
    chargeToAddNote: null,
    isPayChargePopupOpen: false,
    paymentDateQuickOption: new Date(),
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    isNewTaskPopupOpen: false,
    isUndoSavingsPopupOpen: false,
    includeUnpaidFilter: false
  };

  protected middlewares: MiddlewareInterface[] = [
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
    this.textFieldRef = React.createRef();
  }

  public componentWillMount() {
    this.setState({
      ...this.props.app.financeChargesFilterCheckBoxState
    }, () => {
      this.fetchFirstAllCharges(true, () => {
        window.scrollTo({
          top: this.props.app?.financeChargesListPosition
        });
      });

      const agencyBankAccounts: BankAccountInterface[] = this.getAgencyBankAccounts();

      const defaultBankAccount: BankAccountInterface = agencyBankAccounts.find(bankAccount => {
        return bankAccount.isDefault === true;
      });

      let agencyBankAccountId;

      if (!!defaultBankAccount) {
        agencyBankAccountId = !!defaultBankAccount ? defaultBankAccount.id : null;
      } else {
        agencyBankAccountId = !!agencyBankAccounts[0] ? agencyBankAccounts[0].id : null;
      }

      this.setState({
        agencyBankAccountIdForPayment: agencyBankAccountId
      })
    })
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: this.state.filterValue
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
      payload: {
        launchPanelState: false
      }
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.charges?.requestsOutdated && nextProps?.charges?.requestsOutdated) {
      this.fetchFirstAllCharges();
    }
  }

  public fetchFirstAllCharges = (fetchAllCharges?, callback?) => {

    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath] : this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      fetchAllCharges
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    if (this.state.includeReceivableFilter) {
      payload.chargeClassId = ChargeClassContainer.pickIdFromLabel("Receivable");
    }

    if (this.state.includeUnpaidFilter) {
      payload.paid = 0
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        charges: data.charges,
        chargesCount: data.count,
        isFetching: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFilterAllCharges = () => {
    const payload: any = {
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }

    if (this.state.includeReceivableFilter) {
      payload.chargeClassId = ChargeClassContainer.pickIdFromLabel("Receivable");
    }

    if (this.state.includeUnpaidFilter) {
      payload.paid = 0
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          charges: data.charges,
          chargesCount: data.count
        })
      }
    })
  }

  public clearFilterAllCharges = () => {
    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllCharges);

    this.textFieldRef.current.focus();
  }

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      filterValue: event.target.value
    }, () => {
      if (this.state.filterValue === "") {
        this.clearFilterAllCharges();
      }

      this.searchTimer = setTimeout(() => {
        this.setState({
          searchInProgress: true
        }, () => {
          this.paginatorPath = `Finance_Charges_${this.state.filter}_${this.state.dateFilter}_${this.state.filterValue}`;

          this.props.dispatch({
            type: Constants.FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE,
            payload: {
              filter: this.state.filterValue
            }
          });

          this.fetchFirstAllCharges();
        });
      }, this.props.app?.listSearchTimeout);
    });
  }

  public fetchCharges = (startPoint = null) => {
    if (!startPoint || startPoint < 0) {
      startPoint = !!this.state.charges ? this.state.charges.length : 0
    }
    const payload: any = {
      firstItem: startPoint,
      lastItem: !!this.state.charges ? this.state.charges.length + this.props.app.defaultPaginationAmount : 0,
      filterValue: this.state.filterValue,
      isAfterStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
    };

    if (!!this.state.dateFilter) {
      payload.invoiceDate = this.state.dateFilter;
    }
    if (this.state.includeReceivableFilter) {
      payload.chargeClassId = ChargeClassContainer.pickIdFromLabel("Receivable");
    }

    if (this.state.includeUnpaidFilter) {
      payload.paid = 0
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        const chargesArr: ChargeInterface[] = !!this.state.charges ?
          [...this.state.charges.slice(0, startPoint), ...data.charges] : [...data.charges];

        this.setState({
          charges: chargesArr,
          chargesCount: data.count
        });
      }
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    if (!date && (identifier === "firstDateOfStatementPeriodForPayment" || identifier === "dateOfThePayment" || identifier === "paymentDateQuickOption")) {
      return;
    }

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      this.props.dispatch({
        type: Constants.FINANCE_CHARGES_FILTER_DATE_UPDATE_STATE,
        payload: {
          filter: this.state.dateFilter
        }
      });

      this.fetchFirstAllCharges();
    });
  }

  public getAmountsOfFilteredCharges = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.chargesCount;
      case "unpaid":
        return this.state.unpaidChargesCount;
      default:
        return;
    }
  }

  public getFilteredCharges = (filter: string): ChargeInterface[] => {
    switch (filter) {
      case "all":
        return this.state.charges
          .filter((charge: ChargeInterface) => charge.removed === false);

      case "unpaid":
        return this.state.unpaidCharges
          .filter((charge: ChargeInterface) => charge.removed === false);
      default:
        return;
    }
  }

  protected openMenu = (event: any, charge: ChargeInterface, index: number): void => {
    this.selectedCharge = charge;
    this.selectedChargeIndex = index;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public unSettle = (): any => {
    const charge: ChargeInterface = this.state.chargeToUnSettle;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UNSETTLE_START,
      payload: {
        chargeId: charge?.id
      },
      onSuccess: () => {
        this.fetchFirstAllCharges();
        this.setState({ isChargeUnSettlePopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public delete = (): void => {
    const chargeToDelete: ChargeInterface = this.state.chargeToDelete;

    if (
      chargeToDelete?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw")
      || chargeToDelete?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_DELETE_START,
      payload: {
        charge: chargeToDelete
      },
      onSuccess: res => {
        this.fetchFilterAllCharges()
        const charges: ChargeInterface[] = [...this.state.charges];
        const unpaidCharges: ChargeInterface[] = [...this.state.unpaidCharges];
        
        // need this to hide deleted charge from the list immediately
        // if (this.state.filter === "all") {
        //   this.fetchFirstAllCharges()
        //   // charges.splice(this.selectedChargeIndex, 1);
        //   // this.setState({
        //   //   chargesCount: this.state.chargesCount - 1,
        //   //   unpaidChargesCount: !this.selectedCharge.isFullyPaid() ? this.state.unpaidChargesCount - 1 : this.state.unpaidChargesCount
        //   // });
        // } else if (this.state.filter === "unpaid") {
        //   unpaidCharges.splice(this.selectedChargeIndex, 1);
        //   this.setState({
        //     chargesCount: !this.selectedCharge.isFullyPaid() ? this.state.chargesCount - 1 : this.state.chargesCount,
        //     unpaidChargesCount: this.state.unpaidChargesCount - 1
        //   });
        // }

        this.setState({
          charges: [...charges],
          unpaidCharges: [...unpaidCharges],
          removedPayments: res.data.data.removedPayments,
          isChargeRemovePopupOpen: false,
          isSaving: false
        }, () => {
          
          const removedPayments = res.data.data.removedPayments;

          if ((!!this.state.chargeToDelete && this.state.chargeToDelete.amountPaid > 0) &&
            (!!removedPayments && removedPayments.length === 0)) {
            this.setState({
              isSaving: false
            });

            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("textfield-charge-was-deleted-you-can-find-payments"),
                type: "info"
              }
            });
          }
        });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public unlink = (): void => {
    const charge = this.state.chargeToUnlink;

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UNLINK_START,
        payload: {
          charge: charge
        },
        onSuccess: () => {
          this.fetchFirstAllCharges();
          this.setState({ isPaymentUnlinkPopupOpen: false, isSaving: false });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveScrollPosition = () => {
    var top = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public openMemoPopup = (charge: ChargeInterface) => {
    this.setState({
      chargeToAddNote: charge,
      note: charge?.note,
      memoPopupOpen: true,
      anchorEl: null
    });
  }

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      hasModifiedData: true,
    });
  }

  public getCharges = (charges: ChargeInterface[], selectedChargesRows: number[], _callback: any): any => {
    return charges
      .map((charge: ChargeInterface, index: number) => {
        if (!charge) {
          return;
        }

        const shouldShowPaidDate = !!charge.oldestPaymentDate;
        let chargeDetails;

        if (charge && charge.description === "") {
          chargeDetails = `${Formatter.monthYearFormatDate(charge.firstDate) ? `${Formatter.monthYearFormatDate(charge.firstDate)},` : ""} ${Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system)} ${!!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""}`
        } else {
          chargeDetails = `${Formatter.monthYearFormatDate(charge.firstDate) ? `${Formatter.monthYearFormatDate(charge.firstDate)},` : ""} ${charge.description} ${!!charge.relatedEntity ? " - " + charge.relatedEntity.displayName : ""}`
        }

        const isItemSelected = selectedChargesRows.includes(index);
        // const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`charge-${charge.id}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              return this.redirect(`/app/charge/update/${charge.id}`);
            }}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            {/* <TableCell
              padding="checkbox"
              onClick={event => {event.preventDefault(); event.stopPropagation(); callback(event, [index])}}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell> */}

            <TableCell
              style={{
                width: "24px",
                paddingLeft: "10px",
                paddingRight: "5px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "4px"
                }}
              >
                <div
                  style={{ color: charge.getIconColor() }}
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>
              {
                shouldShowPaidDate && (
                  <div style={{ display: "inline-flex", flexDirection: "column" }}>
                    <span>{this.formatter.formatDate(charge?.orderDate)}</span>
                    {/* <span style={{fontSize: "12px", color: "gray"}}>{`${this.trans("status-paid").toLowerCase()}: ${this.formatter.formatDate(charge.oldestPaymentDate)}`}</span> */}
                  </div>
                )
              }
              {
                !shouldShowPaidDate && (
                  <span>{this.formatter.formatDate(charge?.orderDate)}</span>
                )
              }
            </TableCell>
            <TableCell style={{ width: "50%" }}>
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "flex-start" }}>
                  {charge?.name || ""}
                  {charge.creationTypeDisplayName && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px 0px 0px 5px"
                      }}
                    >
                      <div className="list-label creation-type-label">
                        {charge.creationTypeDisplayName}
                      </div>
                    </div>
                  )}
                </div>
                <span style={{ fontSize: "12px", color: "gray" }}>
                  {chargeDetails}
                </span>
              </div>
            </TableCell>
            <TableCell style={{ width: "10%" }}>
              {this.renderChargeMemoIcon(charge)}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "20%" }}>
              {
                <div style={{ display: "inline-flex", flexDirection: "column" }}>
                  <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
                  {this.renderChargeAmountHint(charge)}
                </div>
              }
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, charge, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedCharge && this.selectedCharge.id === charge.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      return this.redirect(`/app/charge/update/${this.selectedCharge.id}`);
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>

                  {/* <MenuItem
                    key={`add-task-btn`}
                    onClick={() => {
                      this.setState({
                        isNewTaskPopupOpen: true,
                        anchorEl: null
                      })
                    }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-task icon-style-launch-panel"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                  </MenuItem> */}

                  <MenuItem
                    key={`add-memo-btn`}
                    onClick={() => this.openMemoPopup(this.selectedCharge)}
                  >
                    <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    className="delete-action"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "remove",
                        entityName: "charge",
                        entity: this.selectedCharge
                      })) {
                        this.openIsBusyPopup();
                        this.setState({ anchorEl: null })
                      } else {
                        this.setState({
                          isChargeRemovePopupOpen: true,
                          chargeToDelete: this.selectedCharge,
                          anchorEl: null
                        })
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectUnselectCharge = (row: number, selectedCharge: ChargeInterface) => {
    if (selectedCharge.amountRemaining === 0 && selectedCharge.amount !== 0) {
      return;
    }

    if (this.state.selectedChargesRows.includes(row)) {
      const selectedChargesRows = this.state.selectedChargesRows.filter(rowId => rowId !== row);
      const selectedCharges = this.state.selectedCharges.filter(charge => charge.id !== selectedCharge.id);

      this.setState({
        selectedChargesRows: selectedChargesRows,
        selectedCharges: selectedCharges
      });
    } else {
      if (this.state.selectedChargesRows.length === this.props.app?.chargesPaymentsLinkedLimitNumber) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("section/charge-info/cannottselectchargemaxchargenumberselected", { amount: this.props.app?.chargesPaymentsLinkedLimitNumber }),
            type: "warning"
          }
        });
      }

      this.setState({
        selectedChargesRows: [...this.state.selectedChargesRows, row],
        selectedCharges: [...this.state.selectedCharges, selectedCharge]
      }, () => {
        if (this.state.selectedCharges.length > 0) {
          this.setState({
            hasModifiedData: true
          });
        }
      });
    }
  }

  public onChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const charge: ChargeInterface = this.getFilteredCharges(this.state.filter)[row];

    this.selectUnselectCharge(row, charge);
  }

  public goToNextStep = () => {
    let paymentClassId: number = this.state.selectedCharges[0].chargeClass.id;
    if (this.state.selectedCharges.some((charge: ChargeInterface) => charge.chargeClass.id !== paymentClassId)) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("section/charge-info/cannotpaychargeswithdifferentclasses"),
          type: "warning"
        }
      });
    }

    //Hack to hide launch panel for feature (pay charges with 1 payment)
    this.props.dispatch({
      type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
      payload: {
        launchPanelState: true
      }
    });


    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_CREATE_CLEAR
    });

    const chargesUnpaidAmount: number = this.state.selectedCharges.map((charge: ChargeInterface) => {
      const amountUnpaid = charge.amountRemaining;

      return amountUnpaid;
    }).reduce((a, b) => a + b, 0);

    const chargesDescriptions: string[] = this.state.selectedCharges.map((charge: ChargeInterface) => {
      return charge.description;
    });

    // looking for contact details to autofill them in payment section
    let chargeContact: PersonInterface | CompanyInterface = this.state.selectedCharges[0].contact || this.state.selectedCharges[0].company;
    let chargeObject: PropertyInterface | UnitInterface | ContractInterface | any;

    if (!chargeContact) {
      chargeObject = !!this.state.selectedCharges[0].property;
      chargeContact = !!chargeObject ? chargeObject.contact : null;
    }

    if (!chargeObject && !chargeContact) {
      chargeObject = !!this.state.selectedCharges[0] && !!this.state.selectedCharges[0].unit.property ? this.state.selectedCharges[0].unit.property : null;
      chargeContact = !!chargeObject ? chargeObject.contact : null;
    }

    if (!chargeObject && !chargeContact) {
      chargeObject = this.state.selectedCharges[0].contract;
      chargeContact = !!chargeObject ? chargeObject.occupant : null;
    }

    let selectedPersonForPayment = null;
    let selectedCompanyForPayment = null;

    if (!!chargeContact && chargeContact instanceof Person) {
      selectedPersonForPayment = chargeContact;
    }

    if (!!chargeContact && chargeContact instanceof Company) {
      selectedCompanyForPayment = chargeContact;
    }

    this.setState({
      step: 2,

      amountForPayment: Formatter.simpleFormatNumber(chargesUnpaidAmount),
      currencyIdForPayment: this.state.selectedCharges[0].currency.getCurrencyId(),
      firstDateOfStatementPeriodForPayment: this.state.selectedCharges[0].firstDate,
      dateOfThePayment: this.state.selectedCharges[0].firstDate,
      typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel("Other")),
      agencyBankAccountIdForPayment: null,
      counterpartyIbanForPayment: "",
      originalCounterpartyIban: "",
      paymentClassId: String(paymentClassId),
      payerChoice: !!selectedCompanyForPayment ? "company" : "person",
      selectedPersonForPayment: selectedPersonForPayment,
      selectedCompanyForPayment: selectedCompanyForPayment,
      descriptionForPayment: chargesDescriptions.join("; "),
      descriptionForPaymentIsManuallyChanged: false,
      hasModifiedData: true
    })
  }

  public openCreateBankAccountPopup = (): void => {
    this.setState({ isCreateBankAccountPopupOpen: true })
  }

  public renderPaymentSection = () => {
    return (
      <div className="box component-payment-create">
        <div className="component-wrapper">
          <div className="component">
            {/* <PaymentSection
              {...this.props}
              hidePaymentChoice={true}
              hideNoPaymentOption={true}
              autoFocusAmount={true}
              paymentChoice={this.state.paymentChoice}
              amountForPayment={this.state.amountForPayment}
              currencyIdForPayment={this.state.currencyIdForPayment}
              firstDateOfStatementPeriodForPayment={this.state.firstDateOfStatementPeriodForPayment}
              dateOfThePayment={this.state.dateOfThePayment}
              typeIdForPayment={this.state.typeIdForPayment}
              agencyBankAccountIdForPayment={this.state.agencyBankAccountIdForPayment}
              counterpartyIbanForPayment={this.state.counterpartyIbanForPayment}
              originalCounterpartyIban={this.state.originalCounterpartyIban}
              counterpartyIbanForPaymentIsManuallyChanged={this.state.counterpartyIbanForPaymentIsManuallyChanged}
              paymentClassId={this.state.paymentClassId}
              disablePaymentClass={true}
              payerChoice={this.state.payerChoice}
              showPayerChoice={true}
              selectedPersonForPayment={this.state.selectedPersonForPayment}
              selectedCompanyForPayment={this.state.selectedCompanyForPayment}
              descriptionForPayment={this.state.descriptionForPayment}
              descriptionForPaymentIsManuallyChanged={this.state.descriptionForPaymentIsManuallyChanged}

              scrollToEndOfPage={false}
              openCreateBankAccountPopup={this.openCreateBankAccountPopup}
              selectDate={this.selectDate}
              changeAmountForPayment={this.changeAmountForPayment}
              changeCurrencyIdForPayment={this.changeCurrencyIdForPayment}
              changePayerChoice={this.changePayerChoice}
              selectPersonForPayment={this.selectPersonForPayment}
              clearPersonForPayment={this.clearPersonForPayment}
              selectCompanyForPayment={this.selectCompanyForPayment}
              clearCompanyForPayment={this.clearCompanyForPayment}
              changePaymentClassId={this.changePaymentClassId}
              changeTypeIdForPayment={this.changeTypeIdForPayment}
              updateAgencyBankAccountIdForPayment={this.updateAgencyBankAccountIdForPayment}
              changeCounterpartyIbanForPayment={this.changeCounterpartyIbanForPayment}
              changeDescriptionForPayment={this.changeDescriptionForPayment}
              saveDetailsBeforeRedirect={this.state.payerChoice === "person" ?
                this.saveDetailsBeforeRedirect.bind(this, ["payUnitCharges", "personCreate"])
                :
                this.saveDetailsBeforeRedirect.bind(this, ["payUnitCharges", "companyCreate"])
              }
              paymentTopHint={this.trans("page/payunitcharges-section/payment-hint", {amount: this.formatter.formatNumber(parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(this.state.amountForPayment)).replace(",", "."))).toFixed(2)), this.props.app.settings.user.currency)})}
            /> */}
          </div>
        </div>
      </div>
    );
  }

  public save = () => {
    const payment: any = {
      amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amountForPayment)).replace(",", ".")).toFixed(2)),
      currencyId: this.state.currencyIdForPayment,
      currency: this.state.currencyIdForPayment,
      firstDateOfStatementPeriod: Time.formatOrNull(this.state.firstDateOfStatementPeriodForPayment),
      dateOfThePayment: Time.formatOrNull(this.state.dateOfThePayment),
      paymentTypeId: Number(this.state.typeIdForPayment),
      agencyBankAccount: this.state.typeNameForPayment === "Bank" ? this.state.agencyBankAccountIdForPayment : null,
      paymentClassId: Number(this.state.paymentClassId),
      description: this.state.descriptionForPayment
    };

    if (this.state.selectedPersonForPayment?.id) {
      payment.contactId = this.state.selectedPersonForPayment?.id;
    }

    if (this.state.selectedCompanyForPayment?.id) {
      payment.companyId = this.state.selectedCompanyForPayment?.id;
    }

    if (Number(this.state.typeIdForPayment) === PaymentTypeContainer.pickIdFromLabel("Bank")) {
      const iban = this.state.counterpartyIbanForPayment;

      if (iban) {
        const company: CompanyInterface = this.props.app.companies.find((company: CompanyInterface) => company.mainBankAccountId === this.state.counterpartyIbanForPayment);
        const person: PersonInterface = this.props.app.persons.find((person: PersonInterface) => person.mainBankAccountId === this.state.counterpartyIbanForPayment);

        if ((!!person &&
          !!this.state.selectedPersonForPayment &&
          (person.id !== this.state.selectedPersonForPayment.id)) || !this.state.selectedPersonForPayment) {
          this.setState({
            ibanUsedForEntity: person
          });
        }

        if ((!!company &&
          !!this.state.selectedCompanyForPayment &&
          (company.id !== this.state.selectedCompanyForPayment.id)) || !this.state.selectedCompanyForPayment) {
          this.setState({
            ibanUsedForEntity: company
          });
        }
      }

      // if (this.state.originalCounterpartyIban &&
      //       this.state.counterpartyIbanForPayment !== this.state.originalCounterpartyIban &&
      //         (!!this.state.selectedPersonForPayment || !!this.state.selectedCompanyForPayment)) {
      //   if (!this.state.ibanWasChanged) {
      //     return this.setState({isSaving: false, changeCounterpdartyIbanPopupOpen: true});
      //   }
      // }

      payment.mainBankAccountId = iban;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_START,
        payload: {
          payment: payment
        },
        onSuccess: payment => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.saving(() => {
            this.props.dispatch({
              type: Constants.GLOBAL_PAYMENT_LINK_START,
              payload: {
                payment: payment,
                chargeIds: this.state.selectedCharges.map((charge: ChargeInterface) => charge.id)
              },
              onSuccess: () => {
                this.props.dispatch({
                  type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
                });

                this.props.dispatch({
                  type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
                  payload: {
                    launchPanelState: false
                  }
                });

                this.setState({
                  step: 1,
                  selectedChargesRows: [],
                  selectedCharges: [],
                  hasModifiedData: false,
                  isSaving: false
                }, () => {
                  this.fetchFirstAllCharges();
                });
              },
              onError: () => {
                this.props.dispatch({
                  type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
                  payload: {
                    launchPanelState: false
                  }
                });

                this.setState({
                  hasModifiedData: true,
                  isSaving: false
                });
              }
            });
          });
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public changeCurrencyIdForPayment = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForPayment: currency,
      hasModifiedData: true
    });
  }

  public changeTypeIdForPayment = (event): void => {
    const type = String(event.target.value);

    this.setState({
      typeNameForPayment: type == PaymentTypeContainer.pickIdFromLabel("Bank") ? "Bank" : null,
      typeIdForPayment: type,
      hasModifiedData: true,
    });
  }

  public updateAgencyBankAccountIdForPayment = (event): void => {
    const bankAccountId: number = event.target.value;

    if (bankAccountId) {
      this.setState({
        agencyBankAccountIdForPayment: bankAccountId,
        hasModifiedData: true
      });
    }
  }

  public addBankAccount = (bankAccount: object): void => {
    this.setState({
      isSaving: true,
      hasModifiedData: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
        payload: {
          bankAccount: bankAccount
        },
        onSuccess: (bankAccount: BankAccountInterface) => {
          this.setState({
            isSaving: false,
            isCreateBankAccountPopupOpen: false,
            agencyBankAccountIdForPayment: bankAccount.id
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public changeCounterpartyIbanForPayment = (event): void => {
    const counterpartyIbanForPayment: string = event.target.value;

    this.setState({
      counterpartyIbanForPayment: counterpartyIbanForPayment,
      counterpartyIbanForPaymentWasChanged: true,
      hasModifiedData: true
    });
  }

  public changePaymentClassId = (event): void => {
    const paymentClassId = String(event.target.value);

    this.setState({
      paymentClassId: paymentClassId,
      hasModifiedData: true
    });
  }

  public changePayerChoice = (event): void => {
    this.clearPersonForPayment();
    this.clearCompanyForPayment();

    const choice: string = event.target.value;

    this.setState({
      payerChoice: choice,
      selectedPersonForPayment: null,
      selectedCompanyForPayment: null,
      hasModifiedData: true,
    });
  }

  public selectPersonForExistingPayments = (person: PersonInterface): void => {
    return this.setState({
      selectedPersonForExistingPayments: person,
    });
  }

  public clearPersonForExistingPayments = (): void => {
    return this.setState({
      selectedPersonForExistingPayments: null
    });
  }

  public selectCompanyForExistingPayments = (company: CompanyInterface): void => {
    return this.setState({
      selectedCompanyForExistingPayments: company
    });
  }

  public clearCompanyForExistingPayments = (): void => {
    return this.setState({
      selectedCompanyForExistingPayments: null
    });
  }

  public selectPersonForPayment = (person: PersonInterface, isManuallySelected: boolean): void => {
    return this.setState({
      selectedPersonForPayment: person,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    }, () => {
      // need this logic to ask if user wants to update iban for person
      if ((!this.state.counterpartyIbanForPayment ||
        (this.state.counterpartyIbanForPayment && !this.state.counterpartyIbanForPaymentIsManuallyChanged))
        && person?.mainBankAccountId) {
        return this.setState({
          counterpartyIbanForPayment: person?.mainBankAccountId,
          originalCounterpartyIban: person?.mainBankAccountId,
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public clearPersonForPayment = (): void => {
    const personMainBankAccountId: string = this.state.selectedPersonForPayment?.mainBankAccountId;

    return this.setState({
      selectedPersonForPayment: null,
      selectedPersonForCharge: null,
      directIndirectCharges: [],
      selectedDirectIndirectChargesRows: [],
      hasModifiedData: true
    }, () => {
      if (personMainBankAccountId === this.state.counterpartyIbanForPayment) {
        return this.setState({
          counterpartyIbanForPayment: "",
          originalCounterpartyIban: "",
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public selectCompanyForPayment = (company: CompanyInterface, isManuallySelected: boolean): void => {
    return this.setState({
      selectedCompanyForPayment: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    }, () => {
      // need this logic to ask if user wants to update iban for person
      if ((!this.state.counterpartyIbanForPayment ||
        (this.state.counterpartyIbanForPayment && !this.state.counterpartyIbanForPaymentIsManuallyChanged))
        && company?.mainBankAccountId) {
        return this.setState({
          counterpartyIbanForPayment: company?.mainBankAccountId,
          originalCounterpartyIban: company?.mainBankAccountId,
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public clearCompanyForPayment = (): void => {
    const companyMainBankAccountId: string = this.state.selectedCompanyForPayment?.mainBankAccountId;

    return this.setState({
      selectedCompanyForPayment: null,
      hasModifiedData: true
    }, () => {
      if (companyMainBankAccountId === this.state.counterpartyIbanForPayment) {
        return this.setState({
          counterpartyIbanForPayment: "",
          originalCounterpartyIban: "",
          counterpartyIbanForPaymentWasChanged: false
        });
      }
    });
  }

  public changeDescriptionForPayment = (event): void => {
    const description: string = event.target.value;
    this.setState({
      descriptionForPayment: description,
      descriptionForPaymentIsManuallyChanged: true,
      hasModifiedData: true
    });
  }

  public changeUnpaidFilter = () => {
    this.setState({
      includeUnpaidFilter: !this.state.includeUnpaidFilter
    }, () => {
      this.fetchFirstAllCharges();
    });

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_LIST_CHECK_FILTER,
      payload: {
        includeUnpaidFilter: !this.state.includeUnpaidFilter,
      }
    });
  }

  public changeIncludeReceivablesFilter = () => {
    this.setState({
      includeReceivableFilter: !this.state.includeReceivableFilter
    }, () => {
      this.fetchFirstAllCharges();
    });

    this.props.dispatch({
      type: Constants.FINANCE_CHARGES_LIST_CHECK_FILTER,
      payload: {
        includeReceivableFilter: !this.state.includeReceivableFilter,
      }
    });
  }
  public saveDraft = (message) => {
    this.setState({
      note: message,
    })
  }

  public saveReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: this.state.note },
          updateMemo: true
        },
        onSuccess: () => {
          this.fetchCharges(this.state.charges?.indexOf(this.state.charges?.find(chargeToFind => chargeToFind.id === charge?.id)))
          // this.fetchFirstAllCharges();
          this.setState({
            isSaving: false,
            memoPopupOpen: false
          })
        },
        onError: () => {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-updated"),
              type: "warning"
            }
          });
          this.setState({ isSaving: false });
        }
      });
    });
  }

  public removeReminder = (charge: ChargeInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_START,
        payload: {
          chargeId: charge?.id,
          charge: { note: "" },
          removeMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          this.fetchFirstAllCharges();

          this.setState({ isSaving: false, memoPopupOpen: false })
        },
        onError: () => {
          this.setState({ isSaving: false });
        }
      });
    });
  }

  public renderChargeMemoIcon = (charge: ChargeInterface) => {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>
          <span data-tip={this.getTipText(charge?.note)}>
            <div className={`icon ${charge?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(charge);
              }}
            >
            </div>
          </span>
          {/* <ReactTooltip place="bottom" /> */}
        </span>
      </div>
    );
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
      return
    }

    if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-pay")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-receive")}`
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans("status-received")}`
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public openChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public render() {
    return (
      <div className="state-app">
        {
          this.state.step === 1 && (
            <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
              <div className="component-header no-paddings">
                <h1>{this.trans("title-finance")}</h1>
                <TabsComponent
                  activeTab={0}
                  {...this.props}
                />
              </div>

              <div className="component-wrapper no-margin-top">
                <Card className="card no-padding">
                  <div className="label-container"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline"
                    }}
                  >
                    <h3 className="card-title">
                      {this.trans("title-charges")}
                    </h3>
                    <div className="button-container">
                      {
                        this.state.selectedChargesRows.length === 0 && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              if (this.checkProcessIsBusy({
                                action: "create",
                                entityName: "charge",
                              })) {
                                this.openIsBusyPopup();
                              } else {
                                // this.openChargeCreatePopup();

                                this.setState({
                                  isCoachNewChargeOpen: true
                                });
                              }
                            }}
                          >
                            {this.trans("button-add-charge")}
                          </Button>
                        )
                      }
                    </div>
                  </div>

                  <div>
                    <div>
                      {
                        this.state.selectedChargesRows.length === 0 && (
                          <div
                            className="list-filters-wrapper"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center"
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.includeUnpaidFilter}
                                    onChange={this.changeUnpaidFilter}
                                    color="primary"
                                  />
                                }
                                label={this.trans("label-include-unpaid-charges")}
                              />


                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.includeReceivableFilter}
                                    onChange={this.changeIncludeReceivablesFilter}
                                    color="primary"
                                  />
                                }
                                label={this.trans("label-include-receivable")}
                              />

                              <DatePickerComponent
                                {...this.props}
                                id="filterDate"
                                name="filterDate"
                                className="scroll-to-filterDate filter-date-list"
                                label={this.trans("finance-charges-filter/date-label/chargesbefore")}
                                initialDate={this.state.dateFilter}
                                onChange={date => this.selectDate(date, "dateFilter")}
                                clearButton={true}
                                error={this.getErrorFor("filterDate")}
                                width="200px"
                              />
                            </div>

                            <div className="table-filterer">
                              <TextField
                                autoComplete="off"
                                type="text"
                                style={{ color: "rgb(0, 188, 212)" }}
                                label={this.trans("label-search")}
                                value={this.state.filterValue}
                                onChange={this.setFilterValue}
                                variant="standard"
                                error={false}
                                inputRef={this.textFieldRef}
                              />
                              {
                                this.state.filterValue !== "" &&
                                <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearFilterAllCharges}></div>
                              }
                              {
                                this.state.searchInProgress &&
                                <div className="search-loader">
                                  <CircularProgress size={20} />
                                </div>
                              }
                            </div>
                          </div>
                        )
                      }

                      {
                        this.state.selectedChargesRows.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              padding: "14px 24px 14px 65px"
                            }}
                          >
                            <Button
                              color="primary"
                              style={{
                                marginRight: "30px"
                              }}
                              onClick={() => {
                                this.setState({
                                  selectedChargesRows: [],
                                  selectedCharges: [],
                                })
                              }}
                            >
                              {this.trans("button-clear")}
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={this.goToNextStep}
                            >
                              {this.trans("button-pay")}
                            </Button>
                          </div>
                        )
                      }
                    </div>
                    <TableComponent
                      {...this.props}
                      paginator={{
                        name: this.paginatorPath,
                        path: this.props.app.paginator
                      }}
                      className="listing-table finance-charges-table with-first-border"
                      rows={this.getCharges(this.getFilteredCharges(this.state.filter), this.state.selectedChargesRows, this.onChargeRowSelection)}
                      rowsLength={this.getAmountsOfFilteredCharges(this.state.filter)}
                      subtitle={this.trans("title-no-charges-to-list")}
                      fetch={this.fetchCharges}
                      isFetching={this.state.isFetching}
                      filtering={this.state.filterValue?.length > 0}
                    />
                  </div>
                </Card>
              </div>
            </div>
          )
        }

        {
          this.state.step === 2 && (
            <div className="box box-full full-width component-finance has-details-page-header">
              <div className="component-header has-back-button">
                <div className="inner-wrapper" style={{ width: "100%" }}>
                  <div
                    className="back-arrow-wrapper"
                    onClick={() => this.setState({ step: 1, hasModifiedData: false })}
                  >
                    <div className="icon icon-ic-arrow-back icon-color"></div>
                  </div>
                  <div className="title-wrapper">
                    <h1>{this.trans("page/paymentcreate-title")}</h1>
                  </div>
                  <div className="button-container">
                    <Button
                      color="primary"
                      onClick={() => {
                        this.props.dispatch({
                          type: Constants.GLOBAL_LAUNCH_PANEL_STATE,
                          payload: {
                            launchPanelState: false
                          }
                        });

                        this.setState({ step: 1, hasModifiedData: false })
                      }
                      }
                    >
                      {this.trans("button-cancel")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.save}
                    >
                      {this.trans("button-finish")}
                    </Button>
                  </div>
                </div>
              </div>

              {this.renderPaymentSection()}
            </div>
          )
        }

        <DeleteEntityPrompt
          {...this.props}
          entityName={'title-charge-delete-from-charge-page-content-dialog'}
          isOpen={this.state.isChargeRemovePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeRemovePopupOpen: false,
            })
          }}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"charge-unsettle-from-charge-page-content-dialog"}
          isOpen={this.state.isChargeUnSettlePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnSettlePopupOpen: false,
            })
          }}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ cannotDeleteSavingsChargeDialog: false })}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.chargeToAddNote}
                saveDraft={this.saveDraft}
                relations={{ chargeId: this.state.chargeToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
                  });

                  this.fetchCharges();
                  this.fetchFilterAllCharges();
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.chargeToAddNote)}
          hideCross={true}
          subtitle={this.state.chargeToAddNote && this.state.chargeToAddNote.displayName ?
            this.state.chargeToAddNote.displayName : ""}
        />

        <QuickPaymentDialog
          {...this.props}
          charge={this.selectedCharge}
          isOpen={this.state.isPayChargePopupOpen}

          initializePage={() => {
            this.setState({
              hasModifiedData: false,
              isPayChargePopupOpen: false
            }, () => {
              this.fetchFirstAllCharges();
            })
          }}

          closeDialog={() => {
            this.setState({
              isPayChargePopupOpen: false,
              isSaving: false,
              anchorEl: null,
            })
          }}
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.selectedCharge}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorEl: null
            })
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'charge-unlink-info'}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={() => {
            this.setState({
              isPaymentUnlinkPopupOpen: false,
            })
          }}
          onDelete={this.unlink}
          type={"button-continue"}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <ChargeCreateDialog
          {...this.props}
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          onCancel={this.closeChargeCreatePopup}
        />

        {this.state.isCoachNewChargeOpen && (
          <CoachNewCharge
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            onCloseCoach={(success: boolean = false, charge) => {
              this.setState({
                isCoachNewChargeOpen: false
              }, () => {
                if (success) {
                  return this.redirect(`/app/charge/update/${charge.id}`)
                }
              })
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    globalTypes: state.globalTypes,
    component: state.payCharges,
  };
};

export default connect(mapStateToProps)(
  Charges
);
